module.exports = __webpack_public_path__ + "static/gallery45-a41e17053c030997339b4d2b99f0546f.png";